module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/logo-90.png"+" 90w",
        images: [{path: __webpack_public_path__ + "assets/images/logo-90.png",width: 90,height: 69}],
        src: __webpack_public_path__ + "assets/images/logo-90.png",
        toString: function(){return __webpack_public_path__ + "assets/images/logo-90.png"},
        
        width: 90,
        height: 69
      }